var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimStateRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Adjudication / Rejected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Adjudication-/-Rejected",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF6640",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3947266,11.9965768 L16.7010261,15.29506 C17.099658,15.7015082 17.099658,16.2955479 16.7010261,16.6941797 C16.2945779,17.1006279 15.7083546,17.1006279 15.3019064,16.701996 L12.0034232,13.3956965 L8.70493995,16.701996 C8.29849178,17.1006279 7.70445214,17.1006279 7.30582028,16.6941797 C6.89937211,16.2955479 6.89937211,15.7015082 7.29800397,15.29506 L10.6043035,11.9965768 L7.29800397,8.69809356 C6.89937211,8.29164539 6.89937211,7.70542207 7.30582028,7.2989739 C7.70445214,6.90034203 8.29849178,6.90034203 8.70493995,7.2989739 L12.0034232,10.6052734 L15.3019064,7.2989739 C15.7083546,6.90034203 16.2945779,6.90034203 16.7010261,7.2989739 C17.099658,7.70542207 17.099658,8.29164539 16.7010261,8.69809356 L13.3947266,11.9965768 Z",
    id: "d",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimStateRejected);
export default __webpack_public_path__ + "static/media/claim-state-rejected.f10e622787dd9ba47bf601b191acc5e9.svg";
export { ForwardRef as ReactComponent };